import { NewStory, Story, GetArticleOrStoryResponse } from '../types';
import axiosConnector from './axiosConnector';
import { toStoryDTO } from '../dto/storyDTO';
import { API_URL } from './axiosConnector';

export const getStories = async (
  page: number = 1,
  sortBy: { id: string, desc: boolean } = { id: 'id', desc: true },
  filters: any = {}
): Promise<GetArticleOrStoryResponse> => {
  try {
    let url = `${API_URL}/stories?page=${page}&orderBy=${sortBy.id}&desc=${sortBy.desc ? 'desc' : 'asc'}`;

    if (filters) {
      Object.keys(filters).forEach((key) => {
        if (filters[key] !== '') {
          url += `&${encodeURIComponent(key)}=${encodeURIComponent(
            filters[key]
          )}`;
        }
      });
    }

    const storiesResponse = await axiosConnector.get<GetArticleOrStoryResponse>(url);
    const stories = storiesResponse.data;

    const transformedStories = stories.data.map(toStoryDTO);
    return {
      data: transformedStories,
      pagination: stories.pagination,
    };
  } catch (error) {
    console.error(error);
    return {
      data: [],
      pagination: { total_records: 0, current_page: 1, total_pages: 1, next_page: null, prev_page: null },
    };
  }
};

export const updateStory = async (
  story: Story
): Promise<Story | null> => {
  if (story.image_url) {
    story.image_url = story.image_url.replace(/-embedded(?!.*-embedded)/, '');
  }

  try {
    const storyResponse = await axiosConnector.patch<Story>(
      `${API_URL}/stories/${story.id}`,
      story
    );

    return toStoryDTO(storyResponse.data);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const createStory = async (
  story: NewStory
): Promise<Story | null> => {
  try {
    const storyResponse = await axiosConnector.post<Story>(
      `${API_URL}/stories`,
      story
    );

    return toStoryDTO(storyResponse.data);
  } catch (error) {
    console.error(error);
    return null;
  }
};


interface DeleteStoryResponse {
  status: string;
}

export const deleteStory = async (
  storyId: number
): Promise<DeleteStoryResponse | null> => {
  try {
    const storyResponse = await axiosConnector.remove<DeleteStoryResponse>(
      `${API_URL}/stories/${storyId}`
    );

    return { status: storyResponse.data.status };
  } catch (error) {
    console.error(error);
    return null;
  }
};
